
import { defineComponent } from 'vue';
import { conteudoSite, Numero } from '@/uteis/conteudo';

export default defineComponent({
    name: 'FaixaNumeros',
    computed: {
        numeros(): Numero[] {
            return conteudoSite.numeros;
        }
    }
});
